var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('Jumbotron',{attrs:{"bground":_vm.jumbotronBgPath}}),_vm._l((_vm.movieCategories),function(item,index){return _c('Categories',{key:index,attrs:{"data":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }